/* eslint-disable react/jsx-fragments */
import React from "react";
import PropTypes from "prop-types";
import pickBy from "lodash-es/pickBy";

import { gatherClasses, isFunction } from "../../lib/utils";
import "./badge.scss";

const getClonedIcon = (icon, align = "left") => {
  if (React.isValidElement(icon)) {
    return React.cloneElement(icon, {
      className: gatherClasses(
        null,
        `oui-label-${align}-icon`,
        icon.props.className
      )
    });
  }

  return null;
};

const isValidBadgeVariant = variant =>
  ["success", "warning", "danger"].includes(variant);

const getLabelNode = label => <span className="oui-label-text">{label}</span>;

const Badge = props => {
  const {
    dataTestId,
    clickable,
    label,
    onClick,
    icon,
    alignIcon,
    style = {},
    active,
    variant
  } = props;
  const { color, backgroundColor } = style;

  return (
    <div
      data-testid={dataTestId}
      className={gatherClasses(
        props,
        "oui-badge",
        clickable ? "oui-clickable" : "",
        active ? "oui-border-primary" : "",
        isValidBadgeVariant(variant)
          ? `oui-badge-variant-${variant} oui-variant`
          : ""
      )}
      style={
        isValidBadgeVariant(variant)
          ? {}
          : pickBy({
              color,
              backgroundColor
            })
      }
    >
      <span
        className={gatherClasses(
          null,
          "oui-badge-label",
          "oui-text-truncate",
          icon && "oui-badge-with-icon"
        )}
      >
        <span
          className={gatherClasses(
            null,
            isFunction(onClick) ? "oui-pointer" : "",
            clickable ? "oui-clickable" : ""
          )}
          onClick={e => {
            if (isFunction(onClick)) {
              onClick(props, e);
            }
          }}
          aria-hidden="true"
        >
          <React.Fragment>
            {alignIcon === "left" && getClonedIcon(icon, "left")}
            {getLabelNode(label)}
            {alignIcon === "right" && getClonedIcon(icon, "right")}
          </React.Fragment>
        </span>
      </span>
    </div>
  );
};

Badge.propTypes = {
  label: PropTypes.string.isRequired,
  clickable: PropTypes.bool,
  onClick: PropTypes.func,
  style: PropTypes.shape({
    color: PropTypes.string,
    backgroundColor: PropTypes.string
  }),
  dataTestId: PropTypes.string,
  icon: PropTypes.node,
  alignIcon: PropTypes.oneOf(["left", "right"]),
  active: PropTypes.bool,
  variant: PropTypes.oneOf(["success", "danger", "warning"])
};

Badge.defaultProps = {
  clickable: true,
  onClick: null,
  dataTestId: "orion-badge",
  alignIcon: "left",
  active: false
};

Badge.displayName = "OrionBadge";

export default Badge;
